import { LitElement, html, css, nothing } from 'lit'
import { customElement, property } from 'lit/decorators'
import { SvgIcons } from '../../voyage-svg-icons/src/voyage-svg-icons'
import { ScheduleChangeEvents } from '../../../src/models/schedule-change-model-impl';
import { ImminentRiskEvents } from '../../../src/models/imminent-risk-model-impl';
import { ImminentRiskModel } from '../../../src/models/imminent-risk-model';

@customElement('minimized-view-popup')
export class MinimizedViewPopup extends LitElement {
    @property({ type: String, attribute: false }) name: string = '';
    @property({ type: String, attribute: false }) type: string = '';

    @property({ type: Boolean, attribute: false }) hasImminentRisk: boolean | null = null;
    private _checkIntervalId?: number;
    static get styles() {
        return [
            css`
                .container-minimize {
                display: flex;
                align-items: center;
                justify-content: space-between;
                min-width: 180px;
                height: 44px;
                padding: 0 14px 0 12px;
                border-radius: 8px;
                font-family: "Maersk Text", sans-serif;
                font-size: 14px;
                box-shadow: 0px 3px 2.6px 0px #e8e8e840;
                cursor: pointer;
                transition: all 0.2s ease;
                user-select: none;
                }

                .neutral {
                background-color: #ffffff;
                border: 1px solid #cfd3d6;
                color: #001b44;
                }

                .alert {
                background-color: #b80012;
                color: #ffffff;
                border: 1px solid #b80012;
                }

                .left {
                display: flex;
                align-items: center;
                gap: 6px;
                }

                .icons {
                display: flex;
                align-items: center;
                gap: 8px;
                }

                .close-icon {
                font-size: 16px;
                cursor: pointer;
                line-height: 1;
                background: none;
                border: none;
                padding: 0;
                transition: opacity 0.2s ease;
                }

                .close-icon:hover {
                opacity: 0.7;
                }
            `,
        ]
    }

    constructor() {
        super()
    }

    connectedCallback() {
        super.connectedCallback();
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }


    private _getIcon() {
        switch (this.name) {
        case 'ETA Change':
            return SvgIcons.calenderCheck;
        case 'Polar Chart':
            return SvgIcons.polarChartIcon;
        case 'Introducing Audio Alert':
            return SvgIcons.infoIcon;
        default:
            return null;
        }
    }

    private _handleClick() {
        let eventName = '';

        switch (this.name) {
        case 'ETA Change':
            eventName = ScheduleChangeEvents.ReviewChange;
            break;
        case 'Polar Chart':
            eventName = ImminentRiskEvents.hasImminentRisk;
            break;
        case 'Introducing Audio Alert':
            eventName = ImminentRiskEvents.onboardAudioAlert;
            break;
        default:
            eventName = '';
        }

        if (!eventName) return;

        if (
            eventName === ImminentRiskEvents.hasImminentRisk ||
            eventName === ImminentRiskEvents.onboardAudioAlert
        ) {
            ImminentRiskModel?.dispatchEvent(
                new CustomEvent(eventName, {
                    detail: {
                        type: this.type,
                        name: this.name,
                        log_id: localStorage.getItem('imminentRiskLogId'),
                    },
                }),
            );
            return;
        }
        this.dispatchEvent(
            new CustomEvent(eventName, {
                detail: { type: this.type, name: this.name },
                bubbles: true,
                composed: true,
            })
        );
    }

    private handleClose(e: Event) {
        e.stopPropagation();
    }

    render() {
        const isNeutral = this.name === 'Introducing Audio Alert';
        const classes = isNeutral
        ? 'container-minimize neutral'
        : 'container-minimize alert';

        const expandIcon = isNeutral ? SvgIcons.expandDark : SvgIcons.expandWhite;
        return html`
            <div class="${classes}" @click=${this._handleClick}>
                <div class="left">
                    <span>${this._getIcon()}</span>
                    <span>${this.name}</span>
                </div>
                <div class="icons">
                <span>${expandIcon}</span>
                ${isNeutral
                    ? html`<button
                                class="close-icon"
                                slot="trigger"
                                @click=${this._handleClick}
                            >
                            </button>`
                    : nothing}
                </div>
            </div>
        `
    }
}
